import React from 'react';
import { FormControl, FormHelperText, MenuItem } from '@mui/material';
import LabelledSelect from '../LabelledSelect';

interface FileTypeSelectorProps {
	disabled?: boolean;
	selected: string;
	setSelected: (newSelection: string) => void;
	options: string[];
	detectedFormat?: string;
	helperTextOverride?: string;
}

const FileTypeSelector: React.FC<FileTypeSelectorProps> = ({
	disabled,
	selected,
	setSelected,
	options,
	detectedFormat,
	helperTextOverride,
}) => {
	return (
		<FormControl fullWidth variant="outlined" disabled={disabled}>
			<LabelledSelect value={selected} onChange={(e) => setSelected(e.target.value)} selectLabel="File Type" testId="file-type-selector">
				{options.map((format) => {
					return (
						<MenuItem key={`opt-${format}`} value={format} data-testid={`file-type-selector-opt-${format}`}>
							{format} {format === detectedFormat ? '(auto-detected)' : ''}
						</MenuItem>
					);
				})}
			</LabelledSelect>

			<FormHelperText>
				{helperTextOverride ||
					'In most cases the detected file type is correct, or you can manually select the file type to ensure it will be processed correctly'}
			</FormHelperText>
		</FormControl>
	);
};

export default FileTypeSelector;
